import React, { useEffect, useRef, useState } from 'react';
import './lottery-list.styles.scss';
import { useNavigate } from 'react-router-dom';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { getCollectionFromDb, getGameElementsFromDb, getLotteryDataFromDb } from '@/utils/getDataFromDb';
import { get, off } from 'firebase/database';
import { set } from 'date-fns';
import { useSelector } from 'react-redux';

const LotteryList = ({
    gameData,
    gameElements,
    gameStats,
    playerList,
    lotteriesToDisplay,
    ticketLists
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const navigate = useNavigate();

    // useEffect(() => {
    //     if (!lotteriesToDisplay || !playerList) return;
    //     let eligiblePlayers = {}
    //     for (let lottery of lotteriesToDisplay) {
    //         const playersWithTickets = Object.values(playerList)
    //         .filter(p => 
    //             p.items && 
    //             p.items[lottery.id] &&
    //             p.items[lottery.id].count > 0
    //         )
    //         eligiblePlayers[lottery.id] = playersWithTickets.map(pl => {
    //             return {
    //                 'name': pl.displayName,
    //                 'count': pl.items[lottery.id].count
    //             }
    //         })
    //         setPlayerCounts({...eligiblePlayers});
    //     }
    // }, [lotteriesToDisplay, playerList])

    

    

    return (
        <div className={`lottery-list ${screenSize}`}>
            {
                (gameStats && lotteriesToDisplay && playerList)
                ?
                lotteriesToDisplay.map(l => {
                    let lotteryId = l.id;
                    let ticketList = ticketLists && ticketLists[lotteryId] ? 
                        {...ticketLists[lotteryId]} : 
                        null;
                    let mostTickets;
                    let mostTicketsPlayer;
                    if (ticketList) {
                        mostTickets = Object.keys(ticketList)
                            .filter(p => p !== 'picked' && p !== 'removed')
                            .sort((a,b) => ticketList[a] < ticketList[b] ? 1 : -1)[0];
                        console.log(mostTickets);
                        mostTicketsPlayer = playerList[mostTickets]?.displayName;
                    }
                    return (
                    <div 
                        key={l.id}
                        className='g-list-item lottery-item'>
                        <div className='lottery-icon-div'>
                            <ImageContainer
                                src={l.icon}
                                className='lottery-icon' />
                        </div>
                        <div className='lottery-text-div'>
                            <div className='lottery-name'>
                                {l.name}
                            </div>
                            {
                                (l.desc) &&
                                <div className='meta'>{
                                    l.desc.length > 120
                                    ? l.desc.substring(0,120) + '...'
                                    :
                                    l.desc
                                }</div>
                            }
                            <div></div>
                            <div>
                                Tickets Collected: <b>{
                                    gameStats && 
                                    gameStats[l.id]
                                    ? gameStats[l.id]
                                    : 0
                                }</b>
                            </div>
                            <div>
                                Players Included: <b>{
                                    ticketList
                                    ? Object.values(ticketList).length
                                    : 0
                                }</b>
                            </div>
                            <div>
                                Player with most tickets: 
                                {
                                    screenSize === 'mobile' || screenSize === 'tablet'
                                    ? <br />
                                    : " "
                                }
                                {
                                    mostTicketsPlayer
                                    ?
                                    <b>
                                       {mostTicketsPlayer} ({ticketList[mostTickets]})
                                    </b>
                                    :
                                    'none'
                                }
                            </div>
                        </div>
                        <div className='buttons'>
                            <button 
                                className='g-button'
                                onClick={() => navigate(l.path)}>
                                Manage
                                <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                        </div>
                    </div>
                    )
                })
                :
                <div className='center-col'>
                    <ThreeDotsLoader />
                </div>
            }
        </div>
    )
}

export default LotteryList